module["exports"] = [
  "Пан",
  "Пані"
];
